export const GET_INVOICE_PAYMENT_HISTORY = "GET_INVOICE_PAYMENT_HISTORY";
export const GET_INVOICE_PAYMENT_HISTORY_SUCCESS = "GET_INVOICE_PAYMENT_SUCCESS";
export const GET_INVOICE_PAYMENT_HISTORY_FAIL = "GET_INVOICE_PAYMENT_FAIL";